import { createContext, useContext } from 'react';

const CurrentUserContext = createContext(null);

export function useCurrentUser() {
  return useContext(CurrentUserContext);
}

export default CurrentUserContext;
